exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-container {\r\n    text-align: center;\r\n    margin: auto;\r\n}\r\n.form-row{\r\n    height: 100vh;\r\n    text-align: center;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/containers/UserInfo/Register.css
// module id = 2980
// module chunks = 0